export class SetViewerParams {
  zones: string[]

  constructor({ zones }: { zones: string[] }) {
    this.zones = zones
  }
}
